export default __webpack_public_path__ + "static/media/forgot-password-step-3-mobile.9a9b6fe7.webp";